(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpl-age-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STAGE_COPY = {
    dog: {
      puppy: {
        name: 'Puppy',
        interp: 'Your dog is in a fast-growth phase. Body, brain, and behavior are all wiring up at the same time, which is exciting and demanding in equal measure.',
        list: [
          'Rapid physical development and high energy bursts followed by deep sleep.',
          'Active socialization and learning windows.',
          'Sensitive digestion and a still-maturing immune system.'
        ],
        goal: 'Steady growth, a calm nervous system, and consistent routines. Focus on quality nutrition, predictable rest, and gentle daily structure.'
      },
      young: {
        name: 'Young Adult',
        interp: 'Your dog is in their physical prime — strong, agile, and emotionally settled. This is the foundation stage for long-term vitality.',
        list: [
          'Peak physical performance and stamina.',
          'Stable behavior patterns and clear preferences.',
          'High recovery capacity and resilience.'
        ],
        goal: 'Lock in consistency. Quality food, regular movement, restorative sleep, and routine wellness checks build the baseline that supports the next decade of life.'
      },
      mature: {
        name: 'Mature Adult',
        interp: 'Outwardly, little has changed. Internally, this is a quiet pivot. Cellular wear and oxidative stress begin to accumulate, and recovery time shifts.',
        list: [
          'Subtle changes in energy, recovery, and weight management.',
          'Joints and connective tissues begin to show normal wear.',
          'Cognitive sharpness remains, but the foundation matters more than ever.'
        ],
        goal: 'Begin proactive support for cellular energy, antioxidant defense, and joint comfort — well before visible signs of aging appear.'
      },
      senior: {
        name: 'Senior',
        interp: 'Your dog is in a stage where small changes matter. Comfort, cognition, and recovery deserve close, gentle attention.',
        list: [
          'Slower recovery from activity and possible joint stiffness.',
          'Shifts in sleep patterns and energy throughout the day.',
          'More sensitivity to environmental stress and routine changes.'
        ],
        goal: 'Help maintain comfort, mobility, and mental engagement. Gentle daily support, soft routines, and consistent connection are foundational.'
      },
      advanced: {
        name: 'Advanced Senior',
        interp: 'Your dog has earned a slower rhythm. The priority is dignity, comfort, and presence — not performance.',
        list: [
          'Lower energy and shorter activity windows.',
          'More need for warmth, soft surfaces, and quiet environments.',
          'Greater sensitivity to changes in food, schedule, and surroundings.'
        ],
        goal: 'Help maintain quality of life. Soft daily structure, gentle support, and close attention to subtle changes matter most now.'
      }
    },
    cat: {
      kitten: {
        name: 'Kitten',
        interp: 'Your cat is in a fast-growth stage. Coordination, social behavior, and physical structure are all developing rapidly.',
        list: [
          'Rapid growth and bursts of intense play.',
          'Active learning, especially around environment and people.',
          'Sensitive digestion and a maturing immune system.'
        ],
        goal: 'Steady growth and a calm environment. Quality nutrition, gentle handling, and predictable routines build a confident adult cat.'
      },
      young: {
        name: 'Young Adult',
        interp: 'Your cat is at their physical peak — agile, curious, and self-assured. This is the right stage to lock in habits that pay off later.',
        list: [
          'Peak agility, hunting drive, and stamina.',
          'Stable social patterns and well-defined preferences.',
          'Strong recovery and resilience.'
        ],
        goal: 'Consistency. Clean hydration, quality nutrition, daily play, and a low-stress environment build the foundation for a long, healthy life.'
      },
      mature: {
        name: 'Mature Adult',
        interp: 'Outwardly, your cat looks the same. Internally, this is a quiet but meaningful window. Cellular wear and oxidative stress begin to shift.',
        list: [
          'Subtle changes in activity level and weight management.',
          'Slightly slower recovery after intense play.',
          'Cognitive sharpness intact, but groundwork starts mattering more.'
        ],
        goal: 'Begin proactive support for cellular energy and antioxidant defense, well before visible signs of aging appear.'
      },
      senior: {
        name: 'Senior',
        interp: 'Your cat is at a stage where small changes matter. Mobility, hydration, and comfort deserve close, gentle attention.',
        list: [
          'Reduced jumping height and slower movement after rest.',
          'Shifts in sleep patterns and grooming routines.',
          'More sensitivity to environmental and dietary changes.'
        ],
        goal: 'Help maintain comfort, mobility, and engagement. Soft surfaces, easy access to favorite spots, and gentle daily support carry weight here.'
      },
      advanced: {
        name: 'Advanced Senior',
        interp: 'Your cat is in a stage that asks for stillness, warmth, and close attention. The priority is dignity and quality of daily life.',
        list: [
          'Lower energy and shorter active windows.',
          'Greater need for warmth, soft surfaces, and quiet.',
          'More sensitivity to changes in food, schedule, and environment.'
        ],
        goal: 'Help maintain quality of life through gentle daily structure, careful observation of subtle changes, and consistent, supportive routines.'
      }
    }
  };

  function ageFromDob(dobStr) {
    if (!dobStr) return null;
    var dob = new Date(dobStr);
    if (isNaN(dob.getTime())) return null;
    var now = new Date();
    if (dob > now) return null;
    var years = now.getFullYear() - dob.getFullYear();
    var months = now.getMonth() - dob.getMonth();
    var days = now.getDate() - dob.getDate();
    if (days < 0) months -= 1;
    if (months < 0) { years -= 1; months += 12; }
    return { years: years, months: months };
  }

  function convert(ageY, sp, size) {
    if (ageY <= 0) return 0;
    if (ageY <= 1) return ageY * 15;
    if (ageY <= 2) return 15 + (ageY - 1) * 9;
    var increment;
    if (sp === 'dog') {
      increment = ({ small: 4, medium: 5, large: 6, giant: 7 })[size] || 5;
    } else {
      increment = 4;
    }
    return 24 + (ageY - 2) * increment;
  }

  function lifeStage(ageY, sp, size) {
    if (sp === 'cat') {
      if (ageY < 1) return 'kitten';
      if (ageY < 4) return 'young';
      if (ageY < 7) return 'mature';
      if (ageY < 11) return 'senior';
      return 'advanced';
    }
    var brackets = ({
      small:  [1, 4, 8, 12],
      medium: [1, 4, 7, 11],
      large:  [1, 3, 6, 9],
      giant:  [1, 3, 5, 8]
    })[size] || [1, 4, 7, 11];
    if (ageY < brackets[0]) return 'puppy';
    if (ageY < brackets[1]) return 'young';
    if (ageY < brackets[2]) return 'mature';
    if (ageY < brackets[3]) return 'senior';
    return 'advanced';
  }

  function formatHuman(num) {
    if (num < 10) return (Math.round(num * 10) / 10).toString();
    return Math.round(num).toString();
  }

  function init(root) {
    if (root.dataset.lplInit === '1') return;
    root.dataset.lplInit = '1';

    var species = root.getAttribute('data-species') || 'dog';
    var form    = root.querySelector('[data-lpl-form]');
    if (!form) return;

    var modeBtns       = form.querySelectorAll('.lpl-ac-mode-btn');
    var paneAge        = form.querySelector('[data-pane="age"]');
    var paneDob        = form.querySelector('[data-pane="dob"]');
    var yearsEl        = form.querySelector('[data-field="years"]');
    var monthsEl       = form.querySelector('[data-field="months"]');
    var dobEl          = form.querySelector('[data-field="dob"]');
    var errorEl        = form.querySelector('[data-error]');
    var resetBtn       = form.querySelector('[data-reset]');
    var resultEl       = root.querySelector('[data-result]');
    var resultNum      = root.querySelector('[data-result-number]');
    var resultSummary  = root.querySelector('[data-result-summary]');
    var stageNameEl    = root.querySelector('[data-stage-name]');
    var stageInterpEl  = root.querySelector('[data-stage-interp]');
    var stageListEl    = root.querySelector('[data-stage-list]');
    var stageGoalEl    = root.querySelector('[data-stage-goal]');

    var mode = 'age';

    function clearError() { errorEl.hidden = true; errorEl.textContent = ''; }
    function setError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }
    function speciesLabel() { return species === 'dog' ? 'dog' : 'cat'; }

    modeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        mode = btn.getAttribute('data-mode');
        modeBtns.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        paneAge.classList.toggle('is-hidden', mode !== 'age');
        paneDob.classList.toggle('is-hidden', mode !== 'dob');
        clearError();
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        form.reset();
        if (resultEl) resultEl.hidden = true;
        clearError();
      });
    }

    function render(humanAge, stageKey) {
      var copy = STAGE_COPY[species][stageKey];
      if (!copy) return;
      resultNum.textContent = formatHuman(humanAge);
      resultSummary.textContent = 'Your ' + speciesLabel() + ' is approximately ' + formatHuman(humanAge) + ' human years old.';
      stageNameEl.textContent = copy.name;
      stageInterpEl.textContent = copy.interp;
      stageListEl.innerHTML = '';
      copy.list.forEach(function (item) {
        var li = document.createElement('li');
        li.textContent = item;
        stageListEl.appendChild(li);
      });
      stageGoalEl.textContent = copy.goal;
      resultEl.hidden = false;
      requestAnimationFrame(function () {
        resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      var years = 0;
      var months = 0;

      if (mode === 'age') {
        years = parseInt(yearsEl.value, 10);
        months = parseInt(monthsEl.value, 10);
        if (isNaN(years)) years = 0;
        if (isNaN(months)) months = 0;
        if (years < 0 || months < 0) { setError('Please enter a positive number.'); return; }
        if (months > 11) { setError('Months must be between 0 and 11.'); return; }
        if (years === 0 && months === 0) { setError('Please enter your ' + speciesLabel() + '’s age.'); return; }
        if (years > 30) { setError('Please enter a realistic age.'); return; }
      } else {
        var parsed = ageFromDob(dobEl.value);
        if (!parsed) { setError('Please enter a valid date of birth.'); return; }
        years = parsed.years;
        months = parsed.months;
        if (years === 0 && months === 0) { setError('Date of birth must be in the past.'); return; }
      }

      var size = null;
      if (species === 'dog') {
        var sizeInput = form.querySelector('input[name="size"]:checked');
        size = sizeInput ? sizeInput.value : 'medium';
      }

      var ageY = years + months / 12;
      var human = convert(ageY, species, size);
      var stage = lifeStage(ageY, species, size);
      render(human, stage);
    });
  }

  function ready() {
    document.querySelectorAll('[data-lpl-ac]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lpl-ac]');
    if (root) init(root);
  });
}());

  } catch(e) { console.error(e); }
})();
})();
